'use client';
import React from 'react';
import RenderFormFields from 'src/components/era-package/forms/RenderFormFields';
import { print7501Form, optionsMap } from 'src/views/abi/fields/print-7501-form';

const Print7501FormModal = ({ formData, setFormData }) => {

  return (
    <RenderFormFields
      fields={print7501Form}
      optionsMap={optionsMap}
      formData={formData || {}}
      setFormData={setFormData}
    />

  );
};

export default Print7501FormModal;